import { Injectable } from '@angular/core'
import { HttpClient as AngularHttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { environment } from '../../environments/environment'

@Injectable()
export class FileManagerService {
    private fileManagerUrl = environment.FILE_MANAGER_URL

    constructor(private httpClient: AngularHttpClient) {}

    getAccessUrl(fileName: string): Promise<any> {
        const url = `${this.fileManagerUrl}/generate-access-url`
        let params = new HttpParams().set('fileName', fileName)
        return this.httpClient.get(url, { params }).toPromise()
    }

    getUploadUrl(fileName: string): Promise<any> {
        const url = `${this.fileManagerUrl}/generate-upload-url`
        let params = new HttpParams().set('fileName', fileName)
        return this.httpClient.get(url, { params }).toPromise()
    }

    uploadFile(uploadUrl: string, file: File): Promise<any> {
        const headers = new HttpHeaders({
            'Content-Type': file.type,
        })

        return this.httpClient.put(uploadUrl, file, {
            reportProgress: true,
            headers: headers,
        }).toPromise()
    }

    deleteFile(fileName: string): Promise<any> {
        const url = `${this.fileManagerUrl}/delete-s3-object`
        let params = new HttpParams().set('fileName', fileName)
        return this.httpClient.get(url, { params }).toPromise()
    }
}



// WEBPACK FOOTER //
// ./src/app/services/file-manager.service.ts